import { useAdminRequests } from '../admin';
import { useDocumentTitle } from '../common';
import { RequestStatus } from '../request-status';

export const AdminApproval = ({ title }: { title: string }) => {
  useDocumentTitle({ title });

  const { requests, apiCallStatus } = useAdminRequests();

  return apiCallStatus === null ? (
    <span>Loading...</span>
  ) : apiCallStatus === false ? (
    <span>Error to get requests to approve.</span>
  ) : apiCallStatus === true && requests.length === 0 ? (
    <span>You have no requests to approve.</span>
  ) : (
    <RequestStatus
      requests={requests}
      requestStatusType="AdminRequestApproval"
    />
  );
};
